import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageHeaderDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        maxWidth: "100%",
        minWidth: 0
    },
    name: {
        flexShrink: 1
    }
});

export const useStyles = ({
    controlPaddings,
    isPlain,
    spaces
}: MessageHeaderDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(!isPlain) {
        styles.container.paddingHorizontal = controlPaddings.small;
    }

    return styles;
};
export default stylesheet;
